import React, { lazy } from 'react';
import { motion } from 'framer-motion';
import { Star } from 'lucide-react';
const testimonials = [{
  photo: 'https://randomuser.me/api/portraits/women/68.jpg',
  name: 'Carla Giménez',
  location: 'Mamá de Tomás, 6 años — Buenos Aires',
  text: 'La primera semana mi hijo señaló la ficha del baño solo. Llevábamos 3 años sin poder anticipar ese momento. Lloré durante 10 minutos seguidos. No lo puedo explicar con palabras.'
}, {
  photo: 'https://randomuser.me/api/portraits/women/44.jpg',
  name: 'Florencia Ruiz',
  location: 'Mamá de Mateo, 5 años — Córdoba',
  text: 'Cada tarde terminaba igual: crisis, gritos, agotamiento total. Yo no sabía cómo ayudarlo. El Método Conecta-TEA me mostró exactamente qué hacer y en qué orden. Las mañanas cambiaron en la primera semana.'
}, {
  photo: 'https://randomuser.me/api/portraits/men/32.jpg',
  name: 'Martín Sosa',
  location: 'Papá de Lucía, 8 años — Rosario',
  text: 'Lo que más me gustó fue que no tuve que improvisar. Todo estaba organizado paso a paso. Le entregué el Manual Escolar a la maestra y en dos meses me llamó para decirme que era el alumno que más había progresado.'
}];
export function TestimonialsTop() {
  return <section className="py-12 md:py-16 bg-stone-50" data-id="element-276">
      <div className="container mx-auto px-4 max-w-6xl" data-id="element-277">
        <div className="grid md:grid-cols-3 gap-8" data-id="element-278">
          {testimonials.map((t, i) => <motion.div key={i} initial={{
          opacity: 0,
          y: 20
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true
        }} transition={{
          delay: i * 0.2
        }} className="bg-white rounded-2xl p-8 shadow-xl shadow-stone-200/50 border border-stone-100 flex flex-col h-full relative" data-id="element-279">
              <div className="flex text-amber-500 mb-6" data-id="element-280">
                {[...Array(5)].map((_, i) => <Star key={i} className="w-5 h-5 fill-current" data-id="element-281" />)}
              </div>

              <p className="text-stone-700 text-lg leading-relaxed mb-8 flex-grow italic" data-id="element-282">
                "{t.text}"
              </p>

              <div className="flex items-center mt-auto pt-6 border-t border-stone-100" data-id="element-283">
                <img src={t.photo} alt={`Foto de ${t.name}`} width={48} height={48} loading="lazy" decoding="async" className="w-12 h-12 rounded-full object-cover mr-4 flex-shrink-0 ring-2 ring-stone-100" data-id="element-284" />
                <div data-id="element-285">
                  <div className="font-bold text-teal-900" data-id="element-286">{t.name}</div>
                  <div className="text-sm text-stone-500" data-id="element-287">{t.location}</div>
                </div>
              </div>
            </motion.div>)}
        </div>
      </div>
    </section>;
}